import { Component } from '@theme/component';
import { fetchConfig, debounce, onAnimationEnd, prefersReducedMotion, resetShimmer } from '@theme/utilities';
import { CartAddEvent } from '@theme/events';
import { cartPerformance } from '@theme/performance';

/** @typedef {import('./utilities').TextComponent} TextComponent */

/**
 * A custom element that displays a cart items component.
 *
 * @typedef {object} Refs
 * @property {HTMLElement[]} quantitySelectors - The quantity selector elements.
 * @property {HTMLTableRowElement[]} cartItemRows - The cart item rows.
 * @property {TextComponent} cartTotal - The cart total.
 *
 * @extends {Component<Refs>}
 */

class CartItemSellingPlan extends Component {
    constructor() {
        super()
        this.selector = this.querySelector('select');
    }

    async onChangeSellingPlan(event) {
        event.preventDefault();
        const planId = parseInt(String(this.selector?.value)) || null;
        const key = this.dataset.key;
        const variantId = parseInt(String(this.dataset.id));
        const quantity = parseInt(String(this.dataset.quantity));
        const properties = JSON.parse(String(this.dataset.properties || '{}'));
        if(!key || !variantId || !quantity) return;

        const body = JSON.stringify({
            updates: { [key]: 0 }
        });
        await fetch(`${Theme.routes.cart_update_url}`, fetchConfig('json', { body }));

        const cartItemsComponents = document.querySelectorAll('cart-items-component');
        const sectionIds = [...cartItemsComponents]
            .filter(el => el instanceof HTMLElement && el.dataset.sectionId)
            .map(el => el.dataset.sectionId);
        const data = {
            id: variantId,
            quantity: quantity,
            selling_plan: planId ? planId : "",
            properties: properties,
            sections: sectionIds.join(',')
        }

        const formData = new FormData();

        const textComponent = /** @type {TextComponent | undefined} */ (this.closest('.cart-items__table-row')?.querySelector('text-component'));
        textComponent?.shimmer();

        Object.entries(data).forEach(([key, value]) => {
            if (key === "properties" && typeof value === "object") {
                Object.entries(value).forEach(([propKey, propValue]) => {
                    formData.append(`properties[${propKey}]`, propValue);
                });
            } else {
                formData.append(key, value);
            }
        });

        const fetchCfg = fetchConfig('javascript', { body: formData } );

        fetch(Theme.routes.cart_add_url, {
            ...fetchCfg,
            headers: {
            ...fetchCfg.headers,
            Accept: 'text/html',
            },
        })
            .then((response) => response.json())
            .then((response) => {
            if (response.status) return; 
            this.dispatchEvent(
                new CartAddEvent({}, variantId.toString(), {
                    source: 'cart-item-selling-plan',
                    sections: response.sections,
                })
            );
            })
            .catch((error) => {
                console.error(error);
            })
            .finally(() => {
                // add more thing to do in here if needed.
                cartPerformance.measureFromEvent('add:user-action', event);
            });
    }
}
if (!customElements.get('cart-item-selling-plan')) {
  customElements.define('cart-item-selling-plan', CartItemSellingPlan);
}